import asArray from 'utils/arrays/asArray.util';
import asObject from 'utils/objects/asObject.util';

/** @param {object | null | undefined} dto */
export const fromDtoToSalonTaxesAndFees = (dto) => {
  const root = asObject(dto);
  const results = asObject(root.results);

  return {
    version: root._v,
    taxes: asArray(results.taxes),
    fees: asArray(results.fees),
  };
};
